<template>
  <MainNavbar class="style-three" />
  <HomeHero />
  <HomeAbout />
  <HomeMenu />
  <HomeCTA />
  <HomeInvestment />
  <FranchiseContact />
  <HomeContact />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import HomeHero from "../components/Home/HomeHero.vue";
import HomeAbout from "../components/Home/HomeAbout.vue";
import HomeMenu from "../components/Home/HomeMenu.vue";
import HomeCTA from "../components/Home/HomeCTA.vue";
import HomeInvestment from "../components/Home/HomeReviews.vue";
import FranchiseContact from "../components/Franchise/FranchiseContact.vue";
import HomeContact from "../components/Home/HomeContact.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    MainNavbar,
    HomeHero,
    HomeAbout,
    HomeMenu,
    HomeCTA,
    HomeInvestment,
    FranchiseContact,
    HomeContact,
  },
});
</script>

<style>
/* Global dark theme */
body {
  background-color: #0a0a0a !important;
}

/* Force white logo on dark background */
.navbar-brand .logo-light,
.logo .logo-light,
.footer-logo .logo-light {
  display: none !important;
}
.navbar-brand .logo-dark,
.logo .logo-dark,
.footer-logo .logo-dark {
  display: block !important;
}

/* Navbar visibility on dark bg */
.navbar-area {
  background-color: rgba(10, 10, 10, 0.9) !important;
  backdrop-filter: blur(12px);
}
.navbar-area .navbar .navbar-nav .nav-item .nav-link,
.navbar-area .navbar .navbar-toggler .burger-menu span {
  color: #ffffff !important;
}
.navbar-area .navbar .navbar-toggler .burger-menu span {
  background: #ffffff !important;
}
.navbar-area .search-form input {
  color: rgba(255, 255, 255, 0.7) !important;
  border-bottom-color: rgba(255, 255, 255, 0.2) !important;
}
.navbar-area .search-form input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}
.navbar-area .search-form button i {
  color: #b5ff00 !important;
}

/* Franchise form on dark home page */
.franchise-application-section {
  background: linear-gradient(135deg, #0a0a0a 0%, #111111 50%, #0f0f0f 100%) !important;
}
</style>
